import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../lib/api";

export interface Integration {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
  connected: boolean;
  connectUrl?: string;
  canDisconnect: boolean;
}

export function useIntegrations() {
  const [integrations, setIntegrations] = useState<Integration[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await apiFetch("/api/integrations");
      if (res.ok) {
        setIntegrations((await res.json()) as Integration[]);
      }
    } catch {
      // Non-critical
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const disconnect = useCallback(
    async (provider: string) => {
      const res = await apiFetch(`/api/integrations/${provider}`, {
        method: "DELETE",
      });
      if (res.ok) {
        refresh();
      }
    },
    [refresh],
  );

  return { integrations, loading, refresh, disconnect };
}
